import React from 'react';

const How = () => (
  <div className="how">
    <h2>支付宝中如何打开付款码？</h2>
    <p>打开支付宝App，点击首页顶部【付款】按钮</p>
    <div className="img-how">
      <img src="/how-alipay-0.png" alt="" />
      <p className="img-tip">点击 ‘付款’</p>
    </div>
    <div className="img-how">
      <img src="/how-alipay-1.png" alt="" />
      <p className="img-tip">得到付款码</p>
    </div>
  </div>
);

export default How;



// WEBPACK FOOTER //
// ./src/pages/Barcode/HowAlipay.js